import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, entityType, isAdmin } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  /**
   * An admin who has not picked an entity is signed in but is not a tenant:
   * every cabinet endpoint refuses that session (401 «Not authenticated as
   * entity»), so the layout could only ever render its frame around an empty
   * page — and the page said "Please login to view services", which is both
   * untranslated and untrue. Same defect as BUG-6, same remedy: send the person
   * where they can act. Narrowed to admins on purpose — they are the only
   * principals who reach the cabinet without an entity (BUG-7).
   */
  if (isAdmin && !entityType) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
}

